
// Move USP bar below the welcome banner
document.addEventListener('DOMContentLoaded', function() {
  var bar = document.querySelector('[id*="announcement-bar"]');
  var banner = document.querySelector('[id*="caasi-welcome-banner"]');
  if (!banner) {
    banner = document.querySelector('[id*="slideshow"]');
  }
  if (bar && banner && bar !== banner) {
    banner.parentNode.insertBefore(bar, banner.nextSibling);
    bar.style.position = 'relative';
    bar.style.zIndex = '3';
  }
});
